// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3jSdS","left":"InfoRow_left__2xnne"};